import styled, { css } from 'styled-components';

import { COLORS } from 'theme';

import Tag from '../..';

export const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.skyBlueDark};
    background: ${COLORS.skyBlueLight};
    border-color: ${COLORS.skyBlue};
    border-radius: ${({ theme }) => theme.borderRadius.full};

    &&& .MuiChip-icon path {
      fill: ${COLORS.skyBlue};
    }
  }

  ${({ $wraps }) =>
    $wraps &&
    css`
      &.MuiChip-root {
        height: auto;
        /* Half the one-line height: a one-line tag still reads as a pill,
           while a taller one keeps its corners clear of the text. */
        border-radius: 14px;
      }

      .MuiChip-label {
        padding-top: ${({ theme }) => theme.spacing.s1};
        padding-bottom: ${({ theme }) => theme.spacing.s1};
        white-space: normal;
      }
    `}
`;

/**
 * MUI already truncates `.MuiChip-label`, but its overflow is invisible to a
 * measurement taken on any ancestor — the chip is capped at `max-width: 100%`,
 * so the ancestor's `scrollWidth` never exceeds its `clientWidth`. Owning the
 * truncation here gives `useIsOverflowing` an element it can actually measure.
 */
export const TagLabel = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ $wraps }) =>
    $wraps &&
    css`
      white-space: normal;
      /* Free text can be one unbroken run, so let it break anywhere. */
      overflow-wrap: anywhere;
    `}
`;
